import { createStore, applyMiddleware } from "redux";
import rootReducer from '../reducers';
import { compose } from "redux";
import logger from "redux-logger";

const store = createStore(
    rootReducer,
    compose(applyMiddleware(logger))
);

export default store;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/store/index.js